module.exports = {
	"featuredAuctionsHeader": "Featured auctions",
	"featuredAuctionsHeaderSmall": "Live and upcoming.",
	"featuredAuctionsMoreBtn": "More featured upcoming auctions",
	"featurette1Header": "Buy & Sell on $t(siteName).",
	"featurette1HeaderMuted": "One stop where buyers and sellers can meet.",
	"featurette1Lead": "Auctioneers can reach more bidders interested in their items and bidders get to know about worldwide auction events.",
	"featurette2Header": "More bidders.",
	"featurette2HeaderMuted": "More bids.",
	"featurette2Lead": "Increase the value and yield of your sales by reaching more bidders and attracting them to your auction events.",
	"featurette3Header": "Worldwide auctions.",
	"featurette3HeaderMuted": "Global access to auctions.",
	"featurette3Lead": "Bid on items in worldwide auction events and reach bidders easily. Remove the barriers preventing you from reaching customers globally.",
	"earlyAccess": "<a>Register today</a> to get an early access and start selling on our live auctioning platform.",
	"organizationCount": "Directory of __organizationCount__ listed auctioneers and sellers.",
	"carousel": {
		"signUpToday": "Sign up today",
		"becomeSeller": "Become a seller today",
		"registerNowSeller": "Register now and create a seller account to list your auctions and your lots on $t(siteName)."
	},
	"imgAlt": {
		"auction": "Drawn auction event",
		"auctioneer": "Auctioneer",
		"hammer": "Auctioneer hammer",
		"paddles": "Bidder paddles",
		"globe": "World globe"
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/home.json5
// module id = 1934
// module chunks = 6